module.exports = __webpack_public_path__ + "assets/img/hill-2.788ea0e7.png";